import React,{ useState, useEffect } from 'react';

import Fig1 from '../../images/hardware-setup/ata-setup-figure-one.png';

function ATASetup() {

    return (
        <div 
            id="router-connectivity-component" 
            className="modem-setup-component modem-connectivity-component"
        >
            <h2>Voice Adapter Connection</h2>
            <img style={{ marginBottom:'1rem' }} src={ Fig1 } />
            <div className='ata-setup-steps-container'>
                <div className='step-item'>
                    <div style={{ fontWeight:600, marginTop:'2rem' }}>Step 1</div>
                    <p style={{ fontSize:'0.9rem' }}>Connect the voice adapter to a power outlet.</p>
                </div>
                <div className='step-item'>
                    <div style={{ fontWeight:600, marginTop:'2rem' }}>Step 2</div>
                    <p style={{ fontSize:'0.9rem' }}>Connect your telephone base to the phone port on the voice adapter.</p>
                </div>
                <div className='step-item'>
                    <div style={{ fontWeight:600, marginTop:'2rem' }}>Step 3</div>
                    <p style={{ fontSize:'0.9rem' }}>Connect the voice adapter to an Ethernet port on your router.</p>
                </div>
            </div>
        </div>
    )
}

export default ATASetup